var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContentLayoutOnly',[_c('b-button',{attrs:{"rounded":"","type":"is-primary"},on:{"click":function($event){return _vm.$refs.adderModal.open()}}},[_vm._v("Add Board Meeting")]),_c('ModernTable',{attrs:{"data-id":"meetings table","columns":_vm.columns,"rows":_vm.rows,"filters":{
      show: true
    },"loading":_vm.loading}}),_c('AdderModal',{ref:"adderModal",attrs:{"_close":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }